/* @flow */
import Glyph from 'components/Glyph.jsx';
import Link from 'components/Link.jsx';
import Organization from 'entities/Organization';
import React, { Component } from 'react';
import CurrentUser from 'auth/CurrentUser';
import cx from 'classnames';

import styles from './styles/GroupAspectTabs.css';

export default class OrgAspectTabs extends Component {
  static propTypes = {
    org: React.PropTypes.instanceOf(Organization),
  };

  static shouldMount = (): boolean => {
    return !CurrentUser.getUser().hasFeature('web_admin_console');
  }

  render() {
    const { org } = this.props;

    const basepath = `/organizations/${org.id}`;
    const activeColor = org.getAccentColor();

    return (
      <nav className={styles.this}>
        <ul className={styles.tabList}>
          <li className={styles.tab}>
            <Link
              to={basepath}
              className={cx(styles.link, styles.activeLink)}>
              <Glyph
                style={{
                  color: activeColor,
                }}
                size="large"
                name="bell-fill"
                className={styles.glyph}
              />
              <span>Verify</span>
            </Link>
          </li>
        </ul>
      </nav>
    );
  }
}



// WEBPACK FOOTER //
// ./src/groups/components/OrgAspectTabs.jsx